import {z} from 'zod'
import {AddressModel} from './address.js'

const NewPackageModel = z.object({
    reseller: z.string(),
    branchId: z.string().max(100).optional(),
    customerId: z.string(),
    status: z.enum(['registered', 'cancelled', 'collected', 'athub', 'delivered', 'return_collected', 'return_athub', 'return_delivered', 'missing', 'manco']),
    events: z.array(z.object({
        timestamp: z.string(),
        status: z.string(),
        orderId: z.string().optional(),
        addressId: z.string().optional(),
        who: z.string().optional(),
        description: z.string().optional()
    })).optional(),
    type: z.string(),
    description: z.string(),
    barcode: z.string().optional(),
    address: AddressModel.optional(),
    addressId: z.string().optional()
})

const PackageModel = NewPackageModel.extend({
    _id: z.string()
})

export {
    NewPackageModel,
    PackageModel
}
